import { State } from 'src/types'
import { deepWeb } from './deepWeb'
import { shallowWeb } from './shallowWeb'

export const webDrawer = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  const isShallowWebModel = ['AKG-JS2'].includes(state.baseModel.productNumber)
  const printLeatherTypeValue = state.printLeatherType?.value
  if (isShallowWebModel) {
    await shallowWeb(ctx, state, printLeatherTypeValue) // 浅めのウェブ
  }
  if (!isShallowWebModel) {
    await deepWeb(ctx, state, printLeatherTypeValue) // 普通・深めのウェブ
  }
}
